/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import _ from 'lodash';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import createIcon from '../../../../assets/images/feather-settings.svg';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import {
  DefaultPlanType,
  planTypeMedicaid,
  radioGroupLabelName,
  actionList,
  openExisting,
  createNew,
  rebateProgramLabelName,
  lemplateTypeName,
  codeDomainList,
  coverTemplate as coverTemplateType,
} from './gridComponents/ConstantData';
import {
  REBATE_SELECT,
  TEMPLATE_NAME_REQUIRED,
  TEMPLATE_TYPE_REQUIRED,
  NO_DATA_TO_DISPLAY,
  ONE_LETTER_FOR_COVER,
} from '../../../../SharedModules/Errors/constantMessageData';
import LetterTemplateTableGrid from './gridComponents/LtTableGrid';
import { letterTemplateTableHead } from './gridComponents/LtTableHead';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  convertHTMLtoBlockmap,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';
import {
  saveLetterTemplateErrorMsgList,
  saveLetterTemplateFilterData,
  getRebateProgramDropdownList,
  getTemplateTypeList,
  saveLetterTemplateDetailList,
  saveFetchLetterTemplateDetailList,
  getTemplateDetail,
  setLetterTemplateExtraState,
  getTemplateByType,
  updatePreviousTemplateVersion,
  updateLetterTemplateList,
  saveLTDMergeFieldList,
  updateLetterTemplateDetailCopyList,
} from '../store/actions';
import { useLocation } from 'react-router-dom';


function LetterTemplateSearch(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const gridRef = React.useRef();
  const getRebateProgramList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.rebateProgram
  );
  const templateTypeList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.templateType
  );
  const planTypeList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.planType
  );
  const searchValue = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.filterData
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages
  );
  const searchErrorMessages = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.errorMessages.searchPage
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const extraState = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.extraState
  );
  const letterTemplateList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.letterTemplateList
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.LetterTemplateReducer.extraState.fullScreenView
        .templateTable
  );
  const fetchLetterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.fetchLetterTemplateDetail
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  // const fetchRebateProgramList = (value) =>
  //   dispatch(getRebateProgramDropdownList(value));
  const fetchTemplateList = (value) => dispatch(getTemplateByType(value));
  const setErrorMessages = (value) =>
    dispatch(saveLetterTemplateErrorMsgList(value));
  const setFilterValueAction = (value) =>
    dispatch(saveLetterTemplateFilterData(value));
  const saveLetterTemplateDetail = (value) =>
    dispatch(saveLetterTemplateDetailList(value));
  const setExtraState = (value) => dispatch(setLetterTemplateExtraState(value));

  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [totalResultCount, setTotalResultCount] = React.useState(0);
  const [templateList, setTemplateList] = React.useState([]);
  const [newPlanTypeList, setNewPlanTypeList] = React.useState([]);
  const [modalView, setModalView] = React.useState(false);
  const [isErrorMsg, setIsErrorMsg] = React.useState(null);
  const [coverTemplate, setCoverTemplate] = React.useState([]);
  const [rebateProList, setRebateProList] = React.useState([]);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [filterValue, setSetFilterValue] = React.useState({
    planTypeCd: null,
    rebateProgramCd: null,
    templateTypeCd: null,
    actionTypeCd: null,
    name: null,
  });
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    setExtraState({
      ...extraState,
      ...val,
    });
  };

  // This run when error msg change and save in redux
  const setErrorStateChange = (key, val) => {
    setErrorMessages({
      ...errorMessages,
      [key]: val,
    });
  };

  // This run when change full screen value and save in redux
  const changeFullScreenView = (view) => {
    const dataSet = {
      ...extraState.fullScreenView,
      templateTable: view,
    };
    setStateChange({ fullScreenView: dataSet });
  };

  const getletterTemplateList = (val) => {
    if (
      val.rebateProgramCd &&
      val.rebateProgramCd !== '-1' &&
      !_.isNull(val.rebateProgramCd)
    ) {
      if (val.templateTypeCd && val.templateTypeCd !== null) {
        setLoading(true);
        fetchTemplateList({
          rebateProgramCd: val.rebateProgramCd,
          templateTypeCd: val.templateTypeCd,
        });
      }
    }
  };

  // Tab highlighter POC
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/letterTemplate') {
          if (!_.isEmpty(searchErrorMessages)) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [searchErrorMessages]);

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  // This Run when isRefresh is true
  React.useEffect(() => {
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => x.navTo === '/letterTemplate' && x.isRefresh)
        .length > 0
    ) {
      dispatch(getTemplateTypeList({ codeDomainList: codeDomainList }));
      setErrorStateChange('searchPage', []);
      const searchVal = {};
      searchVal.rebateProgramCd = '-1';
      if (userDefaults && !_.isEmpty(userDefaults)) {
        searchVal.planTypeCd = userDefaults.planTypeCd
          ? userDefaults.planTypeCd
          : DefaultPlanType;
        searchVal.rebateProgramCd = userDefaults.rebateProgramCd
          ? userDefaults.rebateProgramCd
          : '-1';
      }
      searchVal.templateTypeCd = 'ALL';
      searchVal.actionTypeCd = openExisting;
      searchVal.name = '';
      if (searchVal.planTypeCd) {
        setLoading(true);
        // getRebateProgramDropdownList(searchVal.planTypeCd).then((res) =>
        //   setRebateProList(res)
        // );
      }
      setFilterValueAction({
        ...searchVal,
      });
      const newObj = localStore.map((item) => {
        if (item.navTo === '/letterTemplate' && item.isRefresh) {
          item.isRefresh = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [userDefaults, localStore]);
 React.useEffect(() => {
  if (location.pathname === '/letterTemplate') {
    if (
      searchValue?.rebateProgramCd &&
      searchValue?.templateTypeCd &&
      searchValue?.actionTypeCd === openExisting
    ) {
      getletterTemplateList({
        rebateProgramCd: searchValue.rebateProgramCd,
        templateTypeCd:
          searchValue.templateTypeCd === 'ALL'
            ? extraState.templeType
            : [searchValue.templateTypeCd],
      });
    }
  }
}, [location.pathname]);


  React.useEffect(() => {
    if (searchValue?.planTypeCd) {
      getRebateProgramDropdownList(searchValue?.planTypeCd).then((res) =>
        setRebateProList(res)
      );
    }
  }, [searchValue?.planTypeCd]);

  React.useEffect(() => {
    const list = !_.isEmpty(templateTypeList)
      ? _.union(
          [{ id: 'ALL', name: 'All Letters' }],
          _.map(templateTypeList, (val) => ({
            id: val.codeValueID.codeValue,
            name: val.shortDescription,
          }))
        )
      : [];
    const optionList = !_.isEmpty(templateTypeList)
      ? _.map(templateTypeList, (val) => val.codeValueID.codeValue)
      : [];
    if (filterValue.actionTypeCd !== createNew && filterValue.rebateProgramCd) {
      getletterTemplateList({
        rebateProgramCd: filterValue.rebateProgramCd,
        templateTypeCd: optionList,
      });
    }
    setStateChange({ templeType: optionList });
  }, [templateTypeList]);

  React.useEffect(() => {
    if (!_.isEmpty(planTypeList)) {
      let list = [];
      list = _.map(planTypeList, (val) => {
        return {
          value: val.codeValueID.codeValue,
          name:
            val?.codeValueID?.codeValue === 'FD'
              ? planTypeMedicaid
              : val.shortDescription,
        };
      });
      setNewPlanTypeList(list);
    }
  }, [planTypeList]);

  // This just get new update data from redux to useState
  React.useEffect(() => {
    setSetFilterValue(searchValue);
  }, [searchValue]);

  // This run when changed rebate program list fetch
  React.useEffect(() => {
    let list = [];
    setLoading(false);
    if (!_.isEmpty(rebateProList)) {
      if (
        rebateProList.status === '001' &&
        rebateProList.message === 'SUCESS'
      ) {
        if (!_.isEmpty(rebateProList.data)) {
          list = _.map(rebateProList.data, (val) => {
            return {
              ...val,
              id: val.rebateProgramCd,
              name: `${val.rebateProgramCd} | ${val.shortDescr}`,
            };
          });
        }
      }
    }
    setRebateProgramList(list);
  }, [rebateProList]);

  // get letter template list
  React.useEffect(() => {
    let errorMsg = searchErrorMessages || [];
    errorMsg = !_.isEmpty(errorMsg)
      ? _.filter(
          errorMsg,
          (l) => !_.includes(['letterTemplateList', 'createBtnForCover'], l.id)
        )
      : [];
    if (searchValue.actionTypeCd === openExisting) {
      if (!_.isEmpty(letterTemplateList)) {
        if (
          letterTemplateList.message === 'SUCESS' &&
          letterTemplateList.status === '001'
        ) {
          let list =
            letterTemplateList.data || letterTemplateList.letterTemplate;
          list = _.orderBy(list, ['templateId'], ['asc']);
          if (!_.isEmpty(list)) {
            let list1 = _.cloneDeep(list);
            list1 = _.uniqBy(list1, 'templateId');
            const newList = [];
            list1.forEach((item) => {
              const getList = _.filter(list, ['templateId', item.templateId]);
              if (!_.isEmpty(getList) && getList.length > 1) {
                const newItem = _.maxBy(getList, 'templateVersion');
                newList.push(newItem);
              } else {
                newList.push(item);
              }
            });
            list = newList;
          } else {
            list = [];
            errorMsg.push({
              id: 'letterTemplateList',
              message: NO_DATA_TO_DISPLAY,
            });
          }
          setTemplateList(list);
        } else {
          setTemplateList([]);
          errorMsg.push({
            id: 'letterTemplateList',
            message: NO_DATA_TO_DISPLAY,
          });
        }
      } else {
        setTemplateList([]);
        errorMsg.push({
          id: 'letterTemplateList',
          message: NO_DATA_TO_DISPLAY,
        });
      }
      if (
        searchValue.rebateProgramCd === '' ||
        _.isEmpty(searchValue.rebateProgramCd) ||
        searchValue.rebateProgramCd === -1 ||
        searchValue.rebateProgramCd === '-1'
      ) {
        errorMsg = !_.isEmpty(errorMsg)
          ? _.filter(errorMsg, (l) => l.id !== 'letterTemplateList')
          : [];
      }
    }
    if (searchValue.actionTypeCd === createNew) {
      let btnDis = false;
      if (searchValue.templateTypeCd === 'COVER') {
        if (!_.isEmpty(letterTemplateList)) {
          if (
            letterTemplateList.message === 'SUCESS' &&
            letterTemplateList.status === '001'
          ) {
            const list =
              letterTemplateList.data || letterTemplateList.letterTemplate;
            btnDis = !_.isEmpty(list);
            if (!_.isEmpty(list) && extraState?.coverErr) {
              setModalView(true);
              setIsErrorMsg(ONE_LETTER_FOR_COVER);
              setCoverTemplate(list);
              // errorMsg.push({ id: 'createBtnForCover', message: ONE_LETTER_FOR_COVER })
            }
          }
        }
      }
      setStateChange({ createBtn: btnDis });
    }
    setLoading(false);
    setErrorStateChange('searchPage', errorMsg);
  }, [letterTemplateList]);

  React.useEffect(() => {
    const newState = { ...searchValue };
    if (!_.isEmpty(newState) && !_.isEmpty(rebateProgramList)) {
      const rebateCd = !_.isEmpty(rebateProgramList)
        ? _.filter(rebateProgramList, (l) => l.id === newState.rebateProgramCd)
        : [];
      newState.rebateProgramCd = !_.isEmpty(rebateCd)
        ? rebateCd[0].rebateProgramCd
        : '-1';
      setFilterValueAction({
        ...newState,
      });
    }
  }, [rebateProgramList]);

  // check detail reponse and redirect on detail page
  React.useEffect(() => {
    if (!_.isEmpty(fetchLetterTemplateDetail)) {
      saveLetterTemplateDetail(fetchLetterTemplateDetail);
      setLoading(false);
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/letterTemplateDetail',
        value: 'Letter Detail',
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({ pathname: '/letterTemplateDetail' });
    }
  }, [fetchLetterTemplateDetail]);

  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  const onChangeFilter = (flType, value) => {
    setSetFilterValue({
      ...filterValue,
      [flType]: value,
    });
  };

  const templateTypeListSet = React.useMemo(() => {
    let list = !_.isEmpty(templateTypeList)
      ? _.map(templateTypeList, (val) => ({
          id: val.codeValueID.codeValue,
          name: val.shortDescription,
        }))
      : [];
    list = !_.isEmpty(list)
      ? _.filter(
          list,
          (l) =>
            l.id !== '' && !_.isNull(l.id) && l.name !== '' && !_.isNull(l.name)
        )
      : [];
    if (filterValue.actionTypeCd === openExisting) {
      list = _.union([{ id: 'ALL', name: 'All Letters' }], list);
    }
    return list;
  }, [templateTypeList, filterValue.actionTypeCd, openExisting]);

  // his run when any action change
  const filterAction = React.useCallback(
    (flType, value) => {
      let errorMsg = !_.isEmpty(searchErrorMessages)
        ? _.filter(searchErrorMessages, (l) => l.id !== flType)
        : [];
      const newState = { ...searchValue };
      newState[flType] = value;
      if (flType === 'planTypeCd') {
        dispatch(updateLetterTemplateList([]));
        newState.rebateProgramCd = '-1';
        setLoading(true);
        // getRebateProgramDropdownList(value).then((res) =>
        //   setRebateProList(res)
        // );
      }
      if (
        flType === 'rebateProgramCd' &&
        (newState.rebateProgramCd === '-1' || newState.rebateProgramCd === '')
      ) {
        errorMsg = errorMsg.filter((item) => item.id === 'rebateProgramCd');
        errorMsg.push({ id: 'rebateProgramCd', message: REBATE_SELECT });
        dispatch(updateLetterTemplateList([]));
      }
      if (flType === 'actionTypeCd') {
        newState.name = '';
        // dispatch(updateLetterTemplateList([]));
        if (value === openExisting) {
          newState.templateTypeCd =
            newState.templateTypeCd === 'ALL' || newState.templateTypeCd === ''
              ? 'ALL'
              : newState.templateTypeCd;
        }
        if (value === createNew) {
          newState.templateTypeCd =
            newState.templateTypeCd === 'ALL' ? '' : newState.templateTypeCd;
          setStateChange({ coverErr: true });
          getletterTemplateList({
            rebateProgramCd: newState.rebateProgramCd,
            templateTypeCd: [newState.templateTypeCd],
          });
          if (newState.templateTypeCd === 'COVER') {
            newState.name = 'Cover Letter';
          }
        }
      }
      if (flType === 'planTypeCd' || flType === 'actionTypeCd') {
        errorMsg = [];
      }
      if (
        (flType === 'rebateProgramCd' || flType === 'templateTypeCd') &&
        newState.actionTypeCd === createNew
      ) {
        setStateChange({ coverErr: true });
        getletterTemplateList({
          rebateProgramCd: newState.rebateProgramCd,
          templateTypeCd: [newState.templateTypeCd],
        });
        if (newState.templateTypeCd === 'COVER') {
          newState.name = 'Cover Letter';
        } else {
          newState.name = '';
        }
        errorMsg = !_.isEmpty(errorMsg)
          ? _.filter(errorMsg, (l) => l.id !== 'name')
          : [];
      }
      if (
        newState.actionTypeCd === openExisting &&
        (flType === 'actionTypeCd' ||
          flType === 'rebateProgramCd' ||
          flType === 'templateTypeCd')
      ) {
        getletterTemplateList({
          rebateProgramCd: newState.rebateProgramCd,
          templateTypeCd:
            newState.templateTypeCd === 'ALL'
              ? extraState.templeType
              : [newState.templateTypeCd],
        });
      }
      setErrorStateChange('searchPage', errorMsg);
      setFilterValueAction({
        ...newState,
      });
    },
    [searchValue, searchErrorMessages]
  );

  // This run when move on Template Detail page
  const createLetterTemplate = React.useCallback(
    (actionType, e) => {
      setLoading(false);
      let rebatePass = false;
      let tempTypePass = false;
      let tempNamePass = false;
      const errorMsg = searchErrorMessages || [];
      if (actionType === 'Add' && !_.isEmpty(searchValue)) {
        if (
          !searchValue.rebateProgramCd ||
          _.includes(['-1', ''], searchValue.rebateProgramCd)
        ) {
          errorMsg.push({ id: 'rebateProgramCd', message: REBATE_SELECT });
          rebatePass = false;
        } else {
          rebatePass = true;
        }
        if (
          !searchValue.templateTypeCd ||
          _.includes(['-1', ''], searchValue.templateTypeCd)
        ) {
          errorMsg.push({
            id: 'templateTypeCd',
            message: TEMPLATE_TYPE_REQUIRED,
          });
          tempTypePass = false;
        } else {
          tempTypePass = true;
        }
        if (
          searchValue.actionTypeCd === createNew &&
          (_.isNaN(searchValue.name) || searchValue.name === '')
        ) {
          if (tempTypePass) {
            errorMsg.push({ id: 'name', message: TEMPLATE_NAME_REQUIRED });
          }
          tempNamePass = false;
        } else {
          tempNamePass = true;
        }
      }

      if (
        actionType === 'Update' ||
        (rebatePass && tempTypePass && tempNamePass && _.isEmpty(errorMsg))
      ) {
        dispatch(updateLetterTemplateDetailCopyList([]));
        dispatch(saveFetchLetterTemplateDetailList([]));
        saveLetterTemplateDetail({
          actionType: null,
          searchValue: {},
          detail: {},
        });
        dispatch(
          saveLTDMergeFieldList({
            body: [],
            header: [],
            footer: [],
          })
        );
        setCoverTemplate([]);
        const detailData =
          actionType === 'Update'
            ? e
            : {
                templateTypeCd: searchValue.templateTypeCd,
                rebateProgramCd:
                  searchValue.rebateProgramCd === '-1'
                    ? null
                    : searchValue.rebateProgramCd,
                name:
                  searchValue.templateTypeCd === 'COVER'
                    ? 'Cover Letter'
                    : searchValue.name,
                descr: null,
                templateId: null,
                templateVersion: 1,

                mediaCd: 'PRINT',
                windowAddrInd: 0,
                windowAddrPos: null,
                autoSendInd: 0,
                usedInd: 0,
                includeWithInvoiceInd:
                  searchValue.templateTypeCd === 'COVER' ? 1 : 0,
                defResponseDueInterval:
                  searchValue.templateTypeCd === 'COVER' ? null : 0,
                contactTypeCd: 'INV',
                emailSubject: null,
                recipientTypeCd: 'MFG',

                body: convertHTMLtoBlockmap(''),
                footer: convertHTMLtoBlockmap(''),
                header: convertHTMLtoBlockmap(''),
              };
        const addDefHeader = !!(
          actionType === 'Add' &&
          detailData.templateTypeCd === coverTemplateType
        );
        setStateChange({
          tabs: 'Details',
          coverErr: false,
          addDefHeader: addDefHeader,
        });
        dispatch(updatePreviousTemplateVersion([]));
        if (actionType === 'Update') {
          dispatch(
            getTemplateDetail({
              actionType: 'Update',
              data: {
                templateId: detailData.templateId,
                templateVersion: detailData.templateVersion,
              },
            })
          );
        }
        if (actionType === 'Add') {
          const newState = { ...searchValue };
          newState.name = '';
          setFilterValueAction({
            ...newState,
          });
          saveLetterTemplateDetail({
            actionType: actionType,
            searchValue: { ...detailData },
            detail: { ...detailData },
          });
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.push({
            navTo: '/letterTemplateDetail',
            value: 'Letter Detail',
            isFormDirty: false,
            isFormError: false,
            isFormSave: false,
            isRefresh: true,
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          props.history.push({ pathname: '/letterTemplateDetail' });
        }
      } else {
        setErrorStateChange('searchPage', _.uniqBy(errorMsg, 'id'));
      }
    },
    [searchValue, searchErrorMessages]
  );

  return (
    <div
      className="lettterTemplate p-0"
      data-testid="letter-template-search-component"
    >
      <Spinner load={loading} />
      <div className="tabs-container">
        {!fullScreenView && (
          <CustomSeparator parent1="Maintain" parent2="Letter Template" />
        )}
        {!_.isEmpty(searchErrorMessages) && (
          <DisplayErrorMessages
            errorMessages={
              searchErrorMessages
                ? _.map(searchErrorMessages, (l) => l.message)
                : []
            }
          />
        )}

        {!fullScreenView && (
          <div className="no-margin">
            <div className="row">
              <div className="col-5 col-lg-5 col-md-6 col-sm-7 frr-radio-40per-width">
                <RadioGroupComponent
                  data-testid="plan-type-redio-btn"
                  id="plan-type-radio-btn-action"
                  labelName={radioGroupLabelName}
                  required
                  reqColor
                  optionList={newPlanTypeList || []}
                  defaultValue={filterValue?.planTypeCd}
                  filterAction={(e) => filterAction('planTypeCd', e)}
                  className="log-batch-filter-radio"
                />
              </div>

              <div className="col-4 col-lg-4 col-md-6 col-sm-5 frr-radio-100per-width">
                <RadioGroupComponent
                  data-testid="action-redio-btn"
                  id="action-radio-btn-action"
                  labelName="Action"
                  required
                  reqColor
                  optionList={actionList}
                  defaultValue={filterValue?.actionTypeCd}
                  filterAction={(e) => filterAction('actionTypeCd', e)}
                  className="log-batch-filter-radio"
                />
              </div>

              <div className="col-3 col-lg-3 col-sm-12 col-md-6 d-sm-inline-flex d-md-flex d-lg-block">
                <SelectBoxWithoutBoxComponent
                  data-testid="rebate-program-select-box"
                  className="pt-sm-2"
                  labelName={rebateProgramLabelName}
                  required
                  select
                  isError={
                    !_.isEmpty(searchErrorMessages) &&
                    _.filter(
                      searchErrorMessages,
                      (l) => l.id === 'rebateProgramCd'
                    ).length
                  }
                  placeholder="Please Select One"
                  optionList={rebateProgramList}
                  defaultValue={filterValue?.rebateProgramCd}
                  filterAction={(e) => filterAction('rebateProgramCd', e)}
                />

                <SelectBoxWithoutBoxComponent
                  data-testid="template-type-select-box"
                  className="mt-2 pl-sm-4 pl-md-4 pl-lg-0"
                  labelName={lemplateTypeName}
                  required
                  isError={
                    !_.isEmpty(searchErrorMessages) &&
                    _.filter(
                      searchErrorMessages,
                      (l) => l.id === 'templateTypeList'
                    ).length
                  }
                  select
                  selectedOne={false}
                  placeholder="Please Select One"
                  optionList={templateTypeListSet || []}
                  defaultValue={filterValue?.templateTypeCd}
                  filterAction={(e) => filterAction('templateTypeCd', e)}
                />
              </div>

              {filterValue?.actionTypeCd === 'Create_New' && (
                <div className="col-5 mt-3">
                  <div className="d-flex frr-LT-input-height">
                    <SelectBoxWithoutBoxComponent
                      data-testid="template-name-input"
                      labelName="Template Name"
                      required
                      disabled={filterValue.templateTypeCd === 'COVER' || false}
                      select={false}
                      isError={
                        !_.isEmpty(searchErrorMessages)
                          ? _.filter(
                              searchErrorMessages,
                              (l) => l.id === 'name'
                            ).length
                            ? _.filter(
                                searchErrorMessages,
                                (l) => l.id === 'name'
                              )[0].message
                            : null
                          : null
                      }
                      inputProps={{ maxlength: 30 }}
                      defaultValue={filterValue?.name}
                      filterAction={(e) => onChangeFilter('name', e)}
                      onBlurAction={(e) => filterAction('name', e)}
                    />
                    <div>
                      <Button
                        className="btn btn-success frr-mt-15 frr-btn-width-17 frr-remove-padding"
                        data-testid="add-new-log-batch"
                        disabled={extraState?.createBtn || !isEnablebyRole}
                        onClick={() => createLetterTemplate('Add', null)}
                      >
                        <img
                          className="manufactureImg"
                          alt=""
                          src={createIcon}
                        />{' '}
                        Create New
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {filterValue?.actionTypeCd === openExisting && (
          <div className="mt-2">
            <LetterTemplateTableGrid
              data-testid="template-list-table"
              gridRef={gridRef}
              cellHead={letterTemplateTableHead}
              dataList={templateList}
              gridHeight={fullScreenView ? '70vh' : 352}
              fileName="Letter Template"
              setFullScreenView={() => changeFullScreenView(!fullScreenView)}
              fullScreenView={fullScreenView}
              fullScreenViewTable="Letter Template"
              fullScreenIcon
              filterIcon
              tableHeader
              actionIcon
              setTotalResultCount={setTotalResultCount}
              cellClickedListener={(e) =>
                createLetterTemplate('Update', e.data)
              }
              helpMessage="* On Double Click of Results, system should navigate to Detail page"
            />
            {/* <p className="total-results" tabIndex="0">
              Total Results:
              <b>{totalResultCount}</b>
            </p> */}
          </div>
        )}
      </div>

      {modalView && isErrorMsg && (
        <CommonModal
          className="dialog-420"
          open={modalView}
          viewHeader
          viewAction
          onOk={() => {
            setModalView(false);
            setIsErrorMsg(null);
            createLetterTemplate('Update', coverTemplate[0]);
          }}
          okTitle="Ok"
          onClose={() => {
            setModalView(false);
            setIsErrorMsg(null);
            setStateChange({ coverErr: false });
          }}
          closeTitle="Cancel"
          modalTitle="Warning"
          childrenComponent={<div className="p-3">{isErrorMsg}</div>}
        />
      )}
    </div>
  );
}

export default withRouter(LetterTemplateSearch);
